import { useEffect, useRef, useCallback } from 'react'
import createAiChatChannel from '../../../channels/ai_chat_channel'

function useStreaming(conversationId, callbacks = {}) {
  const subscriptionRef = useRef(null)
  const { onStreamDelta, onStreamComplete, onToolStatus, onError, onConnected, onDisconnected } = callbacks

  useEffect(() => {
    if (!conversationId) return

    // Create subscription
    subscriptionRef.current = createAiChatChannel(conversationId, {
      onMessageReceived: () => {
        // Message received acknowledgment
      },
      onStreamDelta,
      onStreamComplete,
      onToolStatus,
      onError,
      onConnected,
      onDisconnected
    })

    // Cleanup
    return () => {
      if (subscriptionRef.current) {
        subscriptionRef.current.unsubscribe()
        subscriptionRef.current = null
      }
    }
  }, [conversationId])

  const sendMessage = useCallback((content) => {
    if (subscriptionRef.current) {
      subscriptionRef.current.sendMessage(content)
    }
  }, [])

  return { sendMessage }
}

export default useStreaming
